import Vue from "vue";
import { user as userService } from "../../services/index.js";
import LocalStorage from "../../utils/localStorage";
const localStorage = LocalStorage.getService();

const state = {
  token: null,
  uid: localStorage.getUid(),
  settings: {},
  config: {
    pixelTolerance: 5,
    projection: 3794
  },
  pov: {
    zoom: 12,
    center: [1741757, 5870029]
  },
  email: "",
  tokenString: "",
  name: "",
  logo: null
};

const getters = {
  state: state => state,
  settings: state => state.settings
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setSettings(state, settings) {
    state.settings = settings;
  },
  setFromKeycloak(state, keycloak) {
    state.token = keycloak.tokenParsed;
    state.tokenString = keycloak.token;
    state.name = keycloak.tokenParsed.fullName;
  },
  setUser(state, data) {
    state.user = data;
  },
  setData(state, data) {
    state.settings = { pixelTolerance: 10 }; // data.user.settings;
    state.id = data.user.id;
    state.email = data.user.user;
  },
  setLogo(state, logo) {
    state.logo = logo;
  }
};

const actions = {
  async login(context, data) {
    return userService.login(data).then(user => {
      context.commit("setToken", user.token);

      return user;
    });
  },

  async getSettings(context, portal) {
    return userService.get(portal).then(settings => {
      context.commit("setSettings", settings);

      return settings;
    });
  },

  async getUser(context) {
    const data = await userService.get();
    context.commit("setData", data);

    if (data.user.locale && data.user.locale !== Vue.prototype.$locale) {
      Vue.prototype.$locale = data.user.locale;
    }

    return data.user;
  },

  async getLogo(context) {
    return userService.getLogo().then(logo => {
      if (logo) {
        context.commit("setLogo", logo);
      }
      return logo;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
